import PropTypes from 'prop-types';
import FJModalClose from '../../../FJModals/FJModalClose/FJModalClose';
import styles from './FJUploadImageModal.module.less';
import GalleryIcon from '../../../../assets/svg/gallery.svg?react';
import BoardIcon from '../../../../assets/svg/board-line.svg?react';
import { useRef } from 'react';
import FJLocalStore from '../../../../store/FJLocalStore';
import { UPLOAD_FILE_TYPE } from '../../../../config/dataConfig/FJGenerateData';
import { useState } from 'react';
import classNames from 'classnames';

const FJUploadImageModal = ({ onClose, uploadImage, openMediaLibrary }) => {
    const inputRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);

    const handleClick = () => {
        if (window.isEditPage && openMediaLibrary) {
            openMediaLibrary();
        } else {
            inputRef.current.click();
        }
    };

    const handleChange = e => {
        const file = e.target.files[0];
        e.target.value = '';
        if (file) {
            uploadImage && uploadImage(file);
        }
    };

    const handleDragOver = e => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
    };

    const handleDragLeave = e => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
    };

    const handleDrop = e => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
        const file = e.dataTransfer.files[0];
        if (file) {
            uploadImage && uploadImage(file);
        }
    };

    return (
        <div className={styles.container}>
            <FJModalClose onClick={onClose} />
            <div className={styles.title}>{FJLocalStore._('use-image-as-prompt')}</div>

            <div
                className={classNames(styles.content, isDragging ? styles.content_dragging : '')}
                onClick={handleClick}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
            >
                <GalleryIcon />

                <div
                    className={styles.text}
                    dangerouslySetInnerHTML={{ __html: FJLocalStore._('use-image-as-prompt-desc') }}
                ></div>
                <BoardIcon className={styles.board_icon} />
            </div>

            <input
                type='file'
                accept={UPLOAD_FILE_TYPE}
                className={styles.input}
                ref={inputRef}
                onChange={handleChange}
                multiple={false}
            />
        </div>
    );
};

FJUploadImageModal.propTypes = {
    onClose: PropTypes.func,
    uploadImage: PropTypes.func,
    openMediaLibrary: PropTypes.func,
};

export default FJUploadImageModal;
